/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")
	.controller( "ImportGtfsParametersCtrl", ["$scope", function ($scope) {
		$scope.data = {
		};
	}]);